import React from 'react';
import './ResourceModal.css';

const ResourceModal = ({ resource, operations = [], onClose }) => {
    if (!resource) return null;

    const getTypeInfo = (type) => {
        switch(type) {
            case 'personnel':
                return {
                    text: 'Персонал',
                    icon: '👤',
                    description: 'Человеческие ресурсы, сотрудники'
                };
            case 'equipment':
                return {
                    text: 'Оборудование',
                    icon: '🔧',
                    description: 'Техническое оборудование и машины'
                };
            case 'tool':
                return {
                    text: 'Инструмент',
                    icon: '📐',
                    description: 'Инструменты и приспособления'
                };
            default:
                return {
                    text: 'Другой',
                    icon: '📦',
                    description: 'Прочие ресурсы'
                };
        }
    };

    const getStatusInfo = (status) => {
        const statusNumber = Number(status);
        switch (statusNumber) {
            case 1: return { text: 'Активен', class: 'status-active' };
            case 2: return { text: 'Неактивен', class: 'status-inactive' };
            case 3: return { text: 'Занят', class: 'status-busy' };
            default: return { text: 'Неизвестно', class: 'status-inactive' };
        }
    };

    const typeInfo = getTypeInfo(resource.type);
    const statusInfo = getStatusInfo(resource.status);

    const resourceOperations = operations.filter(op => op.resourceId === resource.id);
    const completedOps = resourceOperations.filter(op => op.status === '1').length;
    const inProgressOps = resourceOperations.filter(op => op.status === '3').length;
    const plannedOps = resourceOperations.filter(op => op.status === '6').length;

    return (
        <div className="resource-modal-overlay" onClick={onClose}>
            <div className="resource-modal" onClick={e => e.stopPropagation()}>
                <div className="resource-modal-header">
                    <h2>Информация о ресурсе</h2>
                    <div className="resource-modal-subtitle">
                        Детализированная информация о выбранном ресурсе
                    </div>
                    <button
                        className="resource-modal-close-btn"
                        onClick={onClose}
                        title="Закрыть"
                    >
                        ✕
                    </button>
                </div>

                <div className="resource-modal-content">
                    <div className="resource-header-info">
                        <div className={`resource-icon-large resource-${resource.type}`}>
                            {typeInfo.icon}
                        </div>
                        <div className="resource-title-section">
                            <h1 className="resource-title">{resource.title}</h1>
                            <div className="resource-subtitle">
                                <span className="resource-type-badge">
                                    {typeInfo.icon} {typeInfo.text}
                                </span>
                                <span className={`resource-status-badge ${statusInfo.class}`}>
                                    {statusInfo.text}
                                </span>
                                <span>ID: {resource.id}</span>
                            </div>
                        </div>
                    </div>

                    <div className="resource-details-grid">
                        <div className="resource-detail-card">
                            <div className="resource-detail-title">
                                📝 Тип ресурса
                            </div>
                            <div className="resource-detail-content">
                                <div className="resource-detail-value">
                                    {typeInfo.text}
                                </div>
                                <div className="resource-detail-label">
                                    {typeInfo.description}
                                </div>
                            </div>
                        </div>

                        <div className="resource-detail-card">
                            <div className="resource-detail-title">
                                🏷️ Идентификация
                            </div>
                            <div className="resource-detail-content">
                                <div className="resource-detail-value">
                                    ID: {resource.id}
                                </div>
                                {resource.okp && (
                                    <div className="resource-detail-label">
                                        ОКП: {resource.okp}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="resource-detail-card">
                            <div className="resource-detail-title">
                                📊 Статус
                            </div>
                            <div className="resource-detail-content">
                                <div className={`resource-detail-value ${statusInfo.class}`}>
                                    {statusInfo.text}
                                </div>
                                <div className="resource-detail-label">
                                    Текущее состояние ресурса
                                </div>
                            </div>
                        </div>

                        <div className="resource-detail-card">
                            <div className="resource-detail-title">
                                📈 Статистика
                            </div>
                            <div className="resource-stats">
                                <div className="resource-stat-item">
                                    <span className="resource-stat-value">
                                        {resourceOperations.length}
                                    </span>
                                    <span className="resource-stat-label">
                                        Всего операций
                                    </span>
                                </div>
                                <div className="resource-stat-item">
                                    <span className="resource-stat-value">
                                        {completedOps}
                                    </span>
                                    <span className="resource-stat-label">
                                        Выполнено
                                    </span>
                                </div>
                                <div className="resource-stat-item">
                                    <span className="resource-stat-value">
                                        {inProgressOps}
                                    </span>
                                    <span className="resource-stat-label">
                                        В процессе
                                    </span>
                                </div>
                                <div className="resource-stat-item">
                                    <span className="resource-stat-value">
                                        {plannedOps}
                                    </span>
                                    <span className="resource-stat-label">
                                        Запланировано
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="resource-operations-section">
                        <div className="section-title">Операции ресурса</div>
                        {resourceOperations.length > 0 ? (
                            <div className="operations-list">
                                {resourceOperations.slice(0, 5).map((op, index) => (
                                    <div key={index} className="operation-item">
                                        <div className="operation-item-title">
                                            {op.title || `Операция ${index + 1}`}
                                        </div>
                                        <div className="operation-item-details">
                                            {new Date(op.startDate).toLocaleDateString()} - {new Date(op.endDate).toLocaleDateString()}
                                        </div>
                                    </div>
                                ))}
                                {resourceOperations.length > 5 && (
                                    <div className="more-operations">
                                        И еще {resourceOperations.length - 5} операций...
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="no-operations">
                                📭 У этого ресурса пока нет операций
                            </div>
                        )}
                    </div>

                    <div className="resource-actions">
                        <button
                            className="resource-action-btn primary"
                            onClick={() => {
                                console.log('Просмотр графика для ресурса:', resource);
                                // Здесь можно добавить логику
                            }}
                        >
                            📊 График использования
                        </button>
                        <button
                            className="resource-action-btn secondary"
                            onClick={() => {
                                console.log('Редактирование ресурса:', resource);
                                // Здесь можно добавить логику
                            }}
                        >
                            ✏️ Редактировать
                        </button>
                        <button
                            className="resource-action-btn secondary"
                            onClick={onClose}
                        >
                            ✕ Закрыть
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResourceModal;